import React from "react";
import { TrainingDay } from "../../types/program";

interface TrainingDayCardProps {
  trainingDay: TrainingDay;
  absoluteDayNumber: number;
  onClick?: () => void;
}

const TrainingDayCard: React.FC<TrainingDayCardProps> = ({
  trainingDay,
  absoluteDayNumber,
  onClick,
}) => {
  const baseClasses =
    "p-4 rounded-lg border-2 transition-all duration-200 flex flex-col justify-between";

  const getCardClasses = () => {
    if (trainingDay.is_rest_day) {
      return `${baseClasses} bg-gray-100 dark:bg-gray-800 border-gray-300 dark:border-gray-600 cursor-not-allowed opacity-60`;
    }

    if (onClick) {
      return `${baseClasses} bg-white dark:bg-navy-700 border-gray-200 dark:border-gray-600 hover:border-biafit-primary dark:hover:border-biafit-primary cursor-pointer hover:shadow-md`;
    }

    return `${baseClasses} bg-white dark:bg-navy-700 border-gray-200 dark:border-gray-600`;
  };

  const handleClick = () => {
    if (!trainingDay.is_rest_day && onClick) {
      onClick();
    }
  };

  return (
    <div className={getCardClasses()} onClick={handleClick}>
      <div>
        <h3 className="mb-0 font-medium text-navy-700 dark:text-white">
          Day {absoluteDayNumber}
        </h3>
      </div>
    </div>
  );
};

export default TrainingDayCard;
